import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { DocumentService } from '../../service/document.service';
import { environment } from 'src/environments/environment';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { tap } from 'rxjs';

@Component({
  selector: "app-link-info-box",
  templateUrl: "./link-info-box.component.html",
  styleUrls: ["./link-info-box.component.scss"],
})
export class LinkInfoBoxComponent implements OnInit {
  @Input() documentInfoIds: string[];
  @Input() claimIdentifier: string;

  linkUrl: string;
  isLoading:boolean;

  exportLinkForm: UntypedFormGroup;
  exportLinkData = { expirationDate: new Date() }


  constructor(
    private documentService: DocumentService,
    private formUtilsService: FormUtilsService,
    private fb: UntypedFormBuilder,
    private uiNotification: UiNotificationService
  ) { }

  ngOnInit(): void {

    const defaultDate = new Date();
    defaultDate.setDate(defaultDate.getDate() +30);

    this.exportLinkData.expirationDate = defaultDate;

    this.exportLinkForm = this.fb.group(
      {
        expirationDate: [this.exportLinkData.expirationDate, [Validators.required]]
      });
  }

  generateLink() {
    if (!this.formUtilsService.markFormGroupTouched(this.exportLinkForm)) {
      this.uiNotification.showValidationError();
      return;
    }

    Object.assign(this.exportLinkData, this.exportLinkForm.value);

    this.isLoading = true;
    this.documentService.exportDocumentsAsLink({
      expirationDate: this.exportLinkData.expirationDate,
      claimIdentifier: this.claimIdentifier,
      documentIds: this.documentInfoIds
    }).pipe(tap(() => this.isLoading = false))
    .subscribe(
      (r) => {

        let webAppPath = '';
        if (environment.wepAppName) {
          webAppPath = "/" + environment.wepAppName;
        }

        this.linkUrl = window.location.origin + webAppPath + "/open/documentsExternal/" + r['linkAlias'];

        this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
      });
  }

  public copyLink(): void {
    this.uiNotification.showSuccess('operations.copiedToClibpboard')
  }
}
